import React from 'react';
import PropTypes from 'prop-types';
import {CompleteButton} from '../CompleteButton';
import {DownloadReportButton} from '../DownloadReportButton';
import style from './style.module.scss';

/**
 * EndSimulationBanner:
 *  - Banner displayed on the bottom of Content Section
 *    Displayed at the bottom of last chapter in Notebook
 */
export function EndSimulationBanner(props) {
  const className = `${style.banner} ${props.className}`;
  return (
    <div className={className}>{props.children}</div>
  );
}

EndSimulationBanner.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * List of child components to render on banner
   */
  children: PropTypes.array,
};

EndSimulationBanner.defaultProps = {
  className: '',
};
